import RecordedWebinarType from 'pages/Home/RecordedWebinarType'

export function canPublish(recordedWebinar: RecordedWebinarType): boolean {
  return !!recordedWebinar.video && !!recordedWebinar.video.videoKey
}
